import Paginacion from './paginacion';
export default Paginacion;